import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import { useFeedbackSettings } from "hooks/feedback-settings";
import type React from "react";
import type { FC } from "react";
import { Link } from "react-router-dom";

export interface FeedbackDialogProps {
  targetUrl: string;
}

export const FeedbackDialog: FC<FeedbackDialogProps> = ({ targetUrl }) => {
  const { shouldShow, onIgnore, onSubmit } = useFeedbackSettings();

  const handleClose = (
    _event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason) {
      return;
    }
    onIgnore();
  };

  const handleSubmit = (rating: number) => {
    onSubmit(rating);
  };

  return (
    <Dialog
      open={shouldShow}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Support us with your feedback
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you satisfied with the Imagio® Color Finder?
        </DialogContentText>
        <Stack alignItems="center" mt={2} mb={-2}>
          <Stack direction={"row"}>
            <Link to={targetUrl} target="_blank">
              <IconButton
                title="Very Satisfied"
                color="success"
                onClick={() => handleSubmit(5)}
              >
                <SentimentVerySatisfiedIcon fontSize={"large"} />
              </IconButton>
            </Link>
            <Link to={targetUrl} target="_blank">
              <IconButton
                sx={{ color: "#57975a" }}
                title="Satisfied"
                color="success"
                onClick={() => handleSubmit(4)}
              >
                <SentimentSatisfiedIcon fontSize={"large"} />
              </IconButton>
            </Link>
            <Link to={targetUrl} target="_blank">
              <IconButton
                title="Neutral"
                color="warning"
                onClick={() => handleSubmit(3)}
              >
                <SentimentNeutralIcon fontSize={"large"} />
              </IconButton>
            </Link>
            <Link to={targetUrl} target="_blank">
              <IconButton
                sx={{ color: "#ec4c4c" }}
                title="Dissatisfied"
                color="error"
                onClick={() => handleSubmit(2)}
              >
                <SentimentDissatisfiedIcon fontSize={"large"} />
              </IconButton>
            </Link>
            <Link to={targetUrl} target="_blank">
              <IconButton
                title="Very Dissatisfied"
                color="error"
                onClick={() => handleSubmit(1)}
              >
                <SentimentVeryDissatisfiedIcon fontSize={"large"} />
              </IconButton>
            </Link>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Hide for now</Button>
      </DialogActions>
    </Dialog>
  );
};
